import React from 'react';
import { components } from 'react-select';
import { Checkbox } from '../../../../../atoms';
import { useStyles } from './OptionWithCheckbox.styles';
export function OptionWithCheckbox(props) {
    const classes = useStyles();
    return (React.createElement(components.Option, Object.assign({}, props),
        React.createElement("div", { className: classes.container },
            React.createElement(React.Fragment, null,
                React.createElement(Checkbox, { className: classes.checkbox, checked: props.isSelected, color: "primary" }),
                props.children))));
}
//# sourceMappingURL=OptionWithCheckbox.js.map